import Text from '@app/components/ui/Text/Text';
import { Button } from 'antd';

type CardHeaderProps = {
  title: string;
  onViewAllClick?: () => void;
};

const CardHeader = ({ title, onViewAllClick }: CardHeaderProps) => {
  return (
    <div className="flex w-full items-center justify-between gap-4 px-5 pb-3 pt-5">
      <Text type="label1" untranslatedText={title} />
      <Button type="link" size="small" className="p-0" onClick={onViewAllClick}>
        <Text type="label2" transKey="show-all" color="#0f766e" />
      </Button>
    </div>
  );
};

export default CardHeader;
